import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/ARE.jpg"


export const ARE = () => {    

    return (
        <SongLinks 
        title={"Abwärtsradeleuphorie"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/1qNqdruPbTda1POMV48O0z"}
        spotifyPresaveLink={"https://add-it.feiyr.com/zebrablau/Abw%C3%A4rtsradeleuphorie"}
        appleMusicLink={"https://music.apple.com/de/song/abw%C3%A4rtsradeleuphorie/1818505362"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=6EuBwcR4L6k"}
        youtubeLink={"https://youtu.be/AXUh1VPGOeI"}
        tidalLink={"https://tidal.com/album/440020806"}
        amazonMusicLink={"https://music.amazon.com/albums/B0FBWFCM35?marketplaceId=A1PA6795UKMFR9&musicTerritory=DE&ref=dm_sh_gWcFc0OOWGcHeBb1xUngaNTgT"}
        bandcampLink={"https://mondwild.bandcamp.com/track/abw-rtsradeleuphorie"}
        releaseDate={"2025-07-11T00:00:00+02:00"}/>
    );
}